export default __webpack_public_path__ + "static/media/custom_2_inlet.e36995d7.jpg";